import { type ApiRequest, type ApiResponseSingle, properCallApi } from '../tenantClient';

export interface IGtmRequest {
  tenantId: number | string
}

export interface IGoogleKeyResponse {
  id: number
  googleAnalyticsKey: string
  googleTagManagerKey: string
  gdprCookieBannerHeader: string
  gdprCookieBannerText: string
}

export function loadGTMKey(createTenantRequest: () => ApiRequest) {
  const request = createTenantRequest();
  return async (params: IGtmRequest): Promise<ApiResponseSingle<IGoogleKeyResponse>> => {
    request.method = 'GET';
    request.endpoint.path = `/api/v1/tenants/${params.tenantId}/google_keys`;
    return await properCallApi<ApiResponseSingle<IGoogleKeyResponse>>(request);
  };
}
